import script from "./AuditScoreSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditScoreSummary.vue?vue&type=script&setup=true&lang=js"

import "./AuditScoreSummary.vue?vue&type=style&index=0&id=461450f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461450f7"]])

export default __exports__